import Service from "../Service";

const resource = "Markets/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
  save(obj, requestID) {
    return Service.post(resource + "save", obj, {
      params: { requestID: requestID },
    });
  },
  list(requestID) {
    return Service.post(resource + "list", null, {
      params: { requestID: requestID },
    });
  },
};
